export const PROCEDURE_STEPS = {
  CATEGORIES: 1,
  SUBCATEGORIES: 2,
  SEARCH: 3,
  PREVIEW: 4,
} as const;
